import React, { useState } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Button, Tooltip, Skeleton, Form, Row, Col } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons";
import {
  HomePageHeader,
  HeaderLeftItemsWrapper,
  HeaderRightItemsWrapper,
  HeaderRightItem,
} from "../../Common/UIElements";
import { HMGSelect, ProjectSelect } from "../../Common/DataAttachedElements";

const ViewReportCategoryTopBar = (props) => {
  const history = useHistory();
  const {
    retrieveCategoryData,
    hmg,
    setHmg,
    project,
    setProject,
    ReportCategoriesLoading,
    exportOnClick,
    reportCategoryList,
    setHmgRef,
    setProjectRef,
  } = props;
  return (
    <Skeleton loading={false} active>
      <HomePageHeader>
        <Col xxl={16} xl={16} lg={16}>
          <Form layout="vertical">
            <HeaderLeftItemsWrapper>
              <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                <Form.Item label="Hotel Management Group">
                  <HMGSelect
                    value={hmg}
                    onChange={setHmg}
                    autoDisable
                    setHmgListRef={setHmgRef}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={8} sm={24} xs={24}>
                <Form.Item label="Project">
                  <ProjectSelect
                    hmgId={hmg}
                    value={project}
                    onChange={setProject}
                    disabled={!hmg}
                    setProjectListRef={setProjectRef}
                  />
                </Form.Item>
              </Col>
              <Col xxl={2} xl={2} lg={2} md={2} sm={24} xs={24}>
                <Form.Item label=" ">
                  <Button
                    type="primary"
                    disabled={!(hmg && project)}
                    onClick={retrieveCategoryData}
                    loading={ReportCategoriesLoading}
                  >
                    Go
                  </Button>
                </Form.Item>
              </Col>
            </HeaderLeftItemsWrapper>
          </Form>
        </Col>
        <Col xxl={8} xl={8} lg={8} sm={24} xs={24}>
          <HeaderRightItemsWrapper>
            <HeaderRightItem>
              <Tooltip placement="bottomRight" title="Add Report Category">
                <Button
                  onClick={() => history.push("/report-category/add")}
                  type="link"
                  size="large"
                  icon={<PlusOutlined />}
                >
                  Report Category
                </Button>
              </Tooltip>
            </HeaderRightItem>
            <HeaderRightItem>
              <Tooltip placement="bottomRight" title="Edit Report Category">
                <Button
                  onClick={() => history.push("/report-category/edit")}
                  type="link"
                  size="large"
                  icon={<EditOutlined />}
                >
                  Edit
                </Button>
              </Tooltip>
            </HeaderRightItem>
            <HeaderRightItem>
              <Tooltip placement="bottomRight" title="Export ">
                <Button
                  onClick={exportOnClick}
                  type="link"
                  size="large"
                  icon={
                    <FontAwesomeIcon
                      className="anticon"
                      icon={faCloudDownloadAlt}
                    />
                  }
                  disabled={
                    !(reportCategoryList && reportCategoryList.length > 0)
                  }
                />
              </Tooltip>
            </HeaderRightItem>
          </HeaderRightItemsWrapper>
        </Col>
        {/* </HeaderItems> */}
      </HomePageHeader>
    </Skeleton>
  );
};

ViewReportCategoryTopBar.defaultProps = {
  hmg: undefined,
  project: undefined,
};

ViewReportCategoryTopBar.propTypes = {
  hmg: PropTypes.string,
  setHmg: PropTypes.func.isRequired,
  project: PropTypes.string,
  setProject: PropTypes.func.isRequired,
};

export default ViewReportCategoryTopBar;
